// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import { dateSchema } from "../commonSchemas";

export const path = "create-claim-detail";

export const createClaimDetailParamsSchema = z
  .object({
    message: z.string(),
    claimId: z.string(),
    tempId: z.string().optional(),
  })
  .strict();




export type CreateClaimDetailParams = z.infer<
  typeof createClaimDetailParamsSchema
>;




// receiver/create-claim-detail endpoint
export function createClaimDetail(
  params: z.input<typeof createClaimDetailParamsSchema>
): Promise<void> {
  return requestHandler(
    "receiver/create-claim-detail",
    params,
    undefined,
  );
}

